import { useState } from 'react';


import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Inline from "yet-another-react-lightbox/plugins/inline";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import { ImageAndPdfViewerProps } from './ImageAndPdfViewer';
import { isSupportedDocViewerBrower } from '../../utils/utils';



export default function ImageViewer({ file }: ImageAndPdfViewerProps) {
    const [open, setOpen] = useState(true);
    if(!isSupportedDocViewerBrower()) {
        return (
        <div>
            <img src={URL.createObjectURL(file)} alt={file.name}/>
        </div>)
    }

    return (
        <div>
            <Lightbox
                styles={{ container: { backgroundColor: 'rgba(0, 0, 0, .8)' } }}
                open={open}
                close={() => setOpen(false)}
                slides={[
                    {
                        src: URL.createObjectURL(file)
                    }
                ]}
                inline={{ style: { width: '100%', aspectRatio: '3/2' } }}
                plugins={[Inline, Zoom, Fullscreen]}
                render={{
                    buttonPrev: () => null,
                    buttonNext: () => null
                }}
            />
        </div>
    );
}
